import { Outlet, Route, Routes } from "react-router-dom";
import styled from "styled-components";
import tw, { theme } from "twin.macro";
import browserRoutes from "./common/browserRoutes";
import customEvents from "./common/customEvents";
import ErrorPopup from "./components/ErrorPopup";
import { ProfileContextProvider } from "./context/profileContext";
import { CreateMediaContext } from "./context/useMediaContext";
import useListenerEffect from "./hooks/useListenerEffect";
import { createThemeScreens } from "./hooks/useThemeScreens";
import CreatePost from "./pages/CreatePost";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import UserDetails from "./pages/UserDetails";
import Login, { setLoginStore } from "./sections/Login";
import Navbar from "./sections/Navbar";

export const useMediaHover = CreateMediaContext("(hover: hover)");
export const {useScreen, useMatchScreen} = createThemeScreens(theme("screens") as any);

const App = () => {
  const handleOpenField = () => {
    setLoginStore({ loginFormVisibility: true });
  };

  useListenerEffect(customEvents.openLoginField, handleOpenField);

  return (
    <ProfileContextProvider>
      <Routes>
        <Route
          path="/"
          element={
            <Wrapper>
              <Login />
              <ErrorPopup />
              <Navbar />
              <Outlet />
            </Wrapper>
          }
        >
          {[browserRoutes.index(), browserRoutes.subscribe()].map((route) => (
            <Route path={route} element={<Index />} />
          ))}
          <Route path={browserRoutes.createPost()} element={<CreatePost />} />
          {[browserRoutes.user(), browserRoutes.userLikes()].map((route) => (
            <Route path={route} element={<UserDetails />} />
          ))}
        </Route>

        <Route path="/*" element={<NotFound />} />
      </Routes>
    </ProfileContextProvider>
  );
};

const Wrapper = styled.div(() => [tw`flex flex-col h-screen`]);

export default styled(App)``;
